// One root for every provider-mappings query (§8), so invalidating ['provider-mappings']
// reaches the index list, the three embedded profile lists and the detail page.
export const providerMappingsQueryKeys = {
    all: ['provider-mappings'] as const,
    list: (filter: Record<string, string>) => ['provider-mappings', 'list', filter] as const,
    detail: (id?: string) => ['provider-mappings', 'detail', id] as const,
};
